import colors from '../../../public/colors'


const styles = theme => {
    const { mode } = theme.palette
    return {
        body: {
            backgroundColor: colors[mode].primaryBackground,
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
        },
        childrenContainer: {
            '& > form': {
                display: 'flex',
                flex: '1',
                height: 'auto',
            },
            backgroundColor: colors[mode].primaryBackground,
            boxShadow: 'none',
            display: 'flex',
            flex: '1',
            flexDirection: 'column',
            height: '100%',
            padding: '0px'
        },
        container: {
            backgroundColor: colors[mode].primaryBackground,
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            maxWidth: '650px',
            minHeight: '482px',
            padding: '0px 0px',
            width: '100%',
            [theme.breakpoints.down('sm')]: {
                maxHeight: 'auto',
                padding: '0px 16px',
            }
        },
        contentContainer: {
            borderRadius: '3px',
            boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
        },
        footerContent: {
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'center',
            minHeight: '64px'
        },
        footerDivider: {
            backgroundColor: colors[mode].divider || 'rgba(0, 0, 0, 0.12)',
            border: `1px solid ${colors[mode].divider || 'rgba(0, 0, 0, 0.12)'}`,
            margin: 0
        },
        footerSection: {
            marginTop: 'auto',
            width: '100%'
        },
        helpText: {
            color: 'grey',
            fontSize: '12px',
            fontStyle: 'italic'
        },
        logo: {
            width: '176px;',
        },
        rbccmOnline: {
            color: '#006AC3',
            fontSize: '20px',
            fontWeight: '500',
            height: '24px',
            letterSpacing: '0',
            lineHeight: '24px',
            width: '136px'
        },
        rbccmOnlineContainer: {
            display: 'flex',
            flexDirection: 'column',
            height: '33px',
            justifyContent: 'space-between',
            width: '136px',
        },
        rbccmOnlineDivider: {
            backgroundColor: '#FFC72C',
            height: '3px',
            width: '40px'
        },
        registrationContainer: {
            '@media screen and (max-width: 320px)': {
                minHeight: '40vh',
                padding: '0px'
            },
            borderRadius: '8px',
            boxShadow: 'none',
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            minHeight: '55vh',
            padding: '0px',
            width: '650px'
        },
        title: {
            color: colors[mode].primaryText,
            fontFamily: 'Roboto',
            fontFeatureSettings: '"liga" off, "clig" off',
            fontSize: '20px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '24px'
        },
        titleBox: {
            alignItems: 'center',
            alignSelf: 'stretch',
            background: colors[mode].primaryBackground,
            borderBottom: `1px solid ${colors[mode].divider}`,
            borderRadius: '2px 2px 0 0',
            display: 'flex',
            height: '56px',
            padding: '6px 24px'
        },
        verbiage: {
            backgroundColor: colors[mode].primaryBackground,
            color: colors[mode].secondaryText,
            fontFamily: 'Roboto',
            fontFeatureSettings: '"liga" off, "clig" off',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 400,
            letterSpacing: '0.17px',
            lineHeight: '20px',
            padding: '24px 24px 0px 24px',
            whiteSpace: 'pre-line'
        }

    }
}

export default styles
